import { render, staticRenderFns } from "./add_child_project.vue?vue&type=template&id=62d7de10&scoped=true"
import script from "./add_child_project.vue?vue&type=script&lang=js"
export * from "./add_child_project.vue?vue&type=script&lang=js"
import style0 from "./add_child_project.vue?vue&type=style&index=0&id=62d7de10&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d7de10",
  null
  
)

export default component.exports